import type { EntityOption } from '@/components/EntitySelect';
import { listDepartments } from '@/features/hrm/employees/api';

/**
 * Department picker for recruitment. `JobOpening.department` is a free-text name
 * (not an FK), so options key on the **name**: candidates come from the org's
 * Department list (BE), and a typed value is kept as-is (no extra Department row).
 */
export async function searchDepartmentNames(query: string): Promise<EntityOption[]> {
  const results = await listDepartments(query || undefined);
  return results.map((d) => ({ value: d.name, label: d.name }));
}

/** Allow a free-text department that isn't in the org list yet. */
export async function createDepartmentName(name: string): Promise<EntityOption> {
  const value = name.trim();
  return { value, label: value };
}

/** Value already is the display name, so just echo it (edit mode). */
export async function resolveDepartmentName(value: string): Promise<string | null> {
  return value || null;
}
